// Persisted lightbox preference. Tile-clicks open in lightbox by default,
// but once a user explicitly exits lightbox, subsequent tile-clicks should
// respect that and open in the detail (chrome) view until they re-enter.
const KEY = "mv-lightbox-pref";

export function getLightboxPref(): boolean {
  try {
    const v = window.localStorage.getItem(KEY);
    if (v === "0") return false;
    if (v === "1") return true;
  } catch {
    /* SSR / disabled storage */
  }
  // Default: open in regular detail view (with chrome). Lightbox is opt-in
  // via the fullscreen button — once enabled it sticks across navigations.
  return false;
}

export function setLightboxPref(on: boolean): void {
  try {
    window.localStorage.setItem(KEY, on ? "1" : "0");
  } catch {
    /* ignore */
  }
}
